import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { Cliente, getClienteDefault } from 'src/app/interface/cliente';
import { MunicipioIBGE } from 'src/app/interface/municpio-ibge';
import { CEPService } from 'src/app/service/cep-service';
import { ClienteService } from 'src/app/service/cliente-service';
import { MunicipioIBGEService } from 'src/app/service/municipio-ibge-service';
import { UtilService } from 'src/app/service/util';
import { getProcessoCadastroRevisaoClienteDefault, ProcessoCadastroRevisaoCliente } from '../../../interface/processo-revisao-cadastro-cliente';
import { getProcessoCadastroHistoricoDefault, ProcessoCadastroHistorico } from '../../../interface/processo-cadastro-historico';
import { ClienteLookupService } from 'src/app/service/cliente-lookup-service';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';

@Component({
  selector: 'app-revisao-cadastro-cliente-aprovar',
  templateUrl: './revisao-cadastro-cliente-aprovar.component.html',
  styleUrls: ['./revisao-cadastro-cliente-aprovar.component.css']
})
export class RevisaoCadastroClienteAprovarComponent implements OnInit {

  processoCadastroCliente: ProcessoCadastroRevisaoCliente;
  cliente: Cliente;
  clienteDto: ProcessoCadastroRevisaoCliente;
  NCODIGO: number;
  observacaoEntidade: string;
  listaEstado: Array<PoSelectOption>;
  bloqueiaCampo: string;
  lbloqueiaCampo: boolean;
  itensHistorico: Array<ProcessoCadastroHistorico>;

  observacaoRejeicao: string = '';

  advancedMunicipioIBGEFilters: Array<PoDynamicFormField>;
  columnsMunicipioIBGEFilters: Array<PoLookupColumn>;
  fieldFormaterMunicipioIBGEFilters: ((value: MunicipioIBGE) => string);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public clienteService: ClienteService,
    public clienteLookupService: ClienteLookupService,
    public processoCadastroService: ProcessoCadastroService,
    public municipioIBGEService: MunicipioIBGEService,
    private poDialog: PoDialogService,
    public utilService: UtilService,
    public cepService: CEPService,

  ) {

    this.processoCadastroCliente = getProcessoCadastroRevisaoClienteDefault();
    this.cliente = getClienteDefault();
    this.clienteDto = getProcessoCadastroRevisaoClienteDefault();
    this.NCODIGO = 0;
    this.listaEstado = utilService.getListaEstados();
    this.bloqueiaCampo = "true";
    this.lbloqueiaCampo = true;
    this.itensHistorico = [];
    this.observacaoEntidade = '';

    this.advancedMunicipioIBGEFilters = this.municipioIBGEService.getAdvancedFilter();
    this.columnsMunicipioIBGEFilters = this.municipioIBGEService.getColumnsFilter();
    this.fieldFormaterMunicipioIBGEFilters = this.municipioIBGEService.getFieldFormater;

  }

  @ViewChild('formCadastroCliente', { static: true }) formCadastroCliente!: NgForm;
  @ViewChild('rejeitarModal', { static: true }) rejeitarModal!: PoModalComponent;

  public readonly breadcrumb: PoBreadcrumb = {
    items: [{label: 'Home', action: this.goTo.bind(this)},
      {label: 'Processo Cadastro', action: this.goTo.bind(this)},
      {label: 'Editar', action: this.goTo.bind(this)},
    ]
  };

  goTo(label: string): void {
    if (label === 'Home') {
      this.router.navigateByUrl('/');
    } else {
      this.router.navigateByUrl('/administrativo/revisao-cadastro/lista');
    }
  }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {
      if ('NCODIGO' in params) {
        this.NCODIGO = params['NCODIGO'];
      }
    })

    this.loadData();

  }

  loadData(): void{

    this.processoCadastroService.getProcCadastroCliente(this.NCODIGO).subscribe(processoCadastroCliente => {
      this.processoCadastroCliente = processoCadastroCliente;
      this.municipioIBGEService.estado = this.processoCadastroCliente.cliente.CA1EST;
      this.processoCadastroCliente.CCODIGOLOJA = `${this.processoCadastroCliente.cliente.CA1COD}/${this.processoCadastroCliente.cliente.CA1LOJA}`

      if (this.processoCadastroCliente.CSTATUS_PROCESSO === 'C'){
        this.bloqueiaCampo = "false";
        this.lbloqueiaCampo = false;
      }

      this.processoCadastroService.getProcCadastroHistoricoLista(this.NCODIGO).subscribe(listaHistorico => {
        this.itensHistorico = listaHistorico.items;
        this.itensHistorico.forEach(item => {
          if ( item.CSTATUS === 'C' ){
            this.observacaoEntidade = item.COBSERVACAO;
          }
        })
      });

      this.clienteLookupService.getObjectByValue(`${this.processoCadastroCliente.cliente.CA1COD}${this.processoCadastroCliente.cliente.CA1LOJA}`,"C").subscribe(cliente => {

        this.cliente = {... cliente};

        this.clienteDto = processoCadastroCliente;

      });

    });
  }

  openModalConfirmar() {
    this.poDialog.confirm({
      title: 'Confirmar Cadastro',
      message: 'Deseja realmente confirmar os dados apresentados?',
      confirm: () => this.salvar()
    });
  }

  openModalRejeitar() {
    this.rejeitarModal.open();
  }

  rejeitar() {
    this.processoCadastroService.postClienteRejeitar(this.NCODIGO, this.observacaoRejeicao).subscribe(() => {
      let processoCadastroHistorico = getProcessoCadastroHistoricoDefault();
      processoCadastroHistorico.NCODIGOPROCESSOCADASTRO = this.clienteDto.NPROCESSO;
      processoCadastroHistorico.CSTATUS = 'P';
      processoCadastroHistorico.COBSERVACAO = 'PROCESSO REJEITADO';
      this.processoCadastroService.postHistorico(processoCadastroHistorico).subscribe(() => {
        this.poDialog.alert({
          title: 'Processo Rejeitado',
          message: 'Processo Rejeitado com Sucesso',
          ok: () => this.goTo('')
        });
      });
    });
  }

  salvar() {

    this.clienteService.postCliente(this.clienteDto.cliente).subscribe(() => {
      let processoCadastroHistorico = getProcessoCadastroHistoricoDefault();
      processoCadastroHistorico.NCODIGOPROCESSOCADASTRO = this.clienteDto.NPROCESSO;
      processoCadastroHistorico.CSTATUS = 'F';
      processoCadastroHistorico.COBSERVACAO = 'PROCESSO APROVADO';
      this.processoCadastroService.postHistorico(processoCadastroHistorico).subscribe(() => {
        this.poDialog.alert({
          title: 'Processo Finalizado',
          message: 'Processo Finalizado com Sucesso',
          ok: () => this.goTo('')
        });
      });
    });

  }

  municipioIBGESelecionado(row: MunicipioIBGE) {
    this.clienteDto.cliente.CA1MUN = row.CCC2MUN;
  }

  validForm(): boolean {
    return !(this.formCadastroCliente.valid && !this.lbloqueiaCampo);
  }

  alteraCep() {
    this.cepService.getObjectByValue(this.clienteDto.cliente.CA1CEP).subscribe(cep => {
      if (cep.cep) {
        this.clienteDto.cliente.CA1END = `${cep.logradouro.toUpperCase()}, `;
        this.clienteDto.cliente.CA1BAIRRO = cep.bairro.toUpperCase();
        this.clienteDto.cliente.CA1EST = cep.uf;
        this.clienteDto.cliente.CA1COD_MUN = cep.ibge.substring(2, 7);
        this.municipioIBGEService.estado = cep.uf;
      } else {
        this.clienteDto.cliente.CA1END = '';
        this.clienteDto.cliente.CA1BAIRRO = '';
        this.clienteDto.cliente.CA1EST = '';
        this.clienteDto.cliente.CA1COD_MUN = '';
        this.municipioIBGEService.estado = '';
      }
    });

  }

  public colunasHistorico: Array<PoTableColumn> = [
    {
      property: 'CSTATUS',
      type: 'subtitle',
      width: '7%',
      label: 'Status',
      visible: true,
      subtitles: [
        {value: 'P', color: 'color-01', content: 'P', label: 'Pendente'},
        {value: 'C', color: 'color-10', content: 'C', label: 'Confirmado'},
        {value: 'R', color: 'color-10', content: 'R', label: 'Reenvio'},
        {value: 'F', color: 'color-07', content: 'F', label: 'Finalizado'},
      ]
    },
    {property: 'DDATA'                      , width: '7%' , visible: true, label: 'Data'      , type: 'date'},
    {property: 'CHORA'                      , width: '7%', visible: true, label: 'Hora'},
    {property: 'CCODIGOUSUARIOPROTHEUS_NOME', width: '10%', visible: true, label: 'Usuário'},
    {property: 'COBSERVACAO'                , width: '50%', visible: true, label: 'Observação'},

  ];

  public readonly rejeitarCadastroAction: PoModalAction = {
    action: () => {

      this.rejeitarModal.close();
      this.rejeitar();
    },
    label: 'Rejeitar',
  };


}
